module.exports = __webpack_public_path__ + "static/media/ansh_mehta.384d0c63.png";